webpackJsonp([170786371021445],{

/***/ 795:
/***/ (function(module, exports) {

	module.exports = {"data":{"page":{"id":"/opt/build/repo/content/pages/success/index.md absPath of file >>> MarkdownRemark","html":"<p>Thank you. I will answer to the message as soon as possible.</p>","frontmatter":{"title":"Success"}},"footnote":{"id":"/opt/build/repo/content/parts/footnote.md absPath of file >>> MarkdownRemark","html":"<ul>\n<li>follow my indie maker/digital nomad journey on <a href=\"https://www.instagram.com/keziyah_is\">Instagram</a></li>\n<li>blog theme by <a href=\"https://github.com/greglobinski/gatsby-starter-personal-blog\">gatsby-starter-personal-blog</a></li>\n<li>back to <a href=\"http://keziyah.com\">keziyah.com</a></li>\n</ul>"},"site":{"siteMetadata":{"facebook":{"appId":""}}}},"pathContext":{"slug":"/success/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---success-36aeffdd5d97272c6dff.js